"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const pseudoStyles = variant => ({
  bgColor: variant === 'dark' ? 'gray.600' : 'gray.50'
});
const closeButtonStyles = ({
  variant
}) => ({
  color: variant === 'dark' ? 'white' : 'black',
  fontSize: '0.5rem',
  position: 'absolute',
  top: 0,
  right: 0,
  padding: 4,
  borderTopRightRadius: 4,
  _hover: pseudoStyles(variant),
  _focus: {
    ...pseudoStyles(variant),
    boxShadow: 'outline'
  }
});
var _default = exports.default = closeButtonStyles;